export const formatCnpj = (cnpj) => {
  if (!cnpj || typeof cnpj !== 'string') {
    return '';
  }

  const cleaned = cnpj.replace(/[^a-zA-Z0-9]/g, '');

  if (cleaned.length >= 14) {
    return cleaned.replace(
      /^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})(\d{2}).*/,
      '$1.$2.$3/$4-$5'
    );
  }

  if (cleaned.length >= 12) {
    return cleaned.replace(
      /^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})(\d*)/,
      '$1.$2.$3/$4-$5'
    );
  }

  if (cleaned.length >= 8) {
    return cleaned.replace(
      /^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]*)/,
      '$1.$2.$3/$4'
    );
  }

  if (cleaned.length >= 5) {
    return cleaned.replace(
      /^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]*)/,
      '$1.$2.$3'
    );
  }

  if (cleaned.length >= 2) {
    return cleaned.replace(
      /^([a-zA-Z0-9]{2})([a-zA-Z0-9]*)/,
      '$1.$2'
    );
  }

  return cleaned;
};
